import * as React from "react";

import type { RibbonButtonState } from "../../RibbonButton/next";
import { useRibbonControlLabel } from "../../RibbonButton/next";
import type { RibbonToggleButtonProps } from "../../RibbonToggleButton/next";
import { useCommonRibbonButtonLabelClassNames } from "../../next/commonRibbonButtonStyles.styles";
import { useRibbonButtonVariant } from "../../RibbonButton/next/useRibbonButtonVariant";

// eslint-disable-next-line no-restricted-imports
import { useAppSplitButtonPrimaryToggleButton } from "@1js/acui-button/lib/Next";

export const useRibbonSplitButtonPrimaryToggleButton = (
  props: RibbonToggleButtonProps,
  ref: React.Ref<HTMLButtonElement>
) => {
  "use forget";

  const { dataAutomationType, label, onRenderText, size, variant, variantId } =
    props;

  const ribbonLabel = useRibbonControlLabel(
    label,
    size,
    onRenderText,
    useCommonRibbonButtonLabelClassNames(size)
  );
  const state = useAppSplitButtonPrimaryToggleButton(
    {
      ...props,
      children: size !== "large" ? ribbonLabel : <React.Fragment />,

      dataAutomationType: dataAutomationType ?? "RibbonToggleButton",
    },
    ref
  );

  useRibbonButtonVariant(
    state as RibbonButtonState,
    variant as RibbonButtonState["variant"],
    variantId as RibbonButtonState["variantId"]
  );

  return state;
};
